<template>
  <div>
    <loading fullscrean="true" v-if="load"/>
    <div class="text-center" style="padding: 25vh 0 10vh" v-else>
      <i class="fa fa-link fa-3x"></i>
      <h5 class="mt-3">Ops! Este link mudou!</h5>
      <div v-if="url">
        <p class="mb-4">Clique no botão abaixo para acessar o novo link.</p>
        <a :href="url" class="btn btn-outline-primary">Acessar</a>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../../../components/Loading'

export default {
  name: 'Blank',
  components: { Loading },
  data() {
    return {
      load: false
    }
  },

  computed: {
    url() {
      return this.$store.state.url_site;
    }
  }
}
</script>

<style scoped>
</style>